/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  console.log('Getting cart')
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
      console.log('on error');

      
      
    },
    complete: function(jqxhr, text) {
      console.log('on complete');
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);

      if ((typeof callback) === 'function') {
        callback(null);
      }
      
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, fgp_rendered, $body, freeShippingThreshold, freeShippingTypes;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var renderSuggestedProducts, cartFBT, updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    
    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true,
      loadingIndicator   : '<div class="cart-lds-ring"><div></div><div></div><div></div><div></div></div></div>'
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;
    
    // Price to qualify for free shipping
    freeShippingThreshold = window.theme?.freeShippingThreshold;
    freeShippingTypes = window.theme?.freeShippingTypes;


    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled and use-ajax data is undefined or true
    if (!settings.disableAjaxCart && $addToCart.length && $addToCart.data('use-ajax') !== false) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {

    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $('.site-header__cart-indicator').removeClass('hide');

      if (cart.item_count === 0) {
        $('.site-header__cart-indicator').addClass('hide');
      }
    }
  };

  formOverride = function (){

    const selector = settings.formSelector.slice(1);
    var forms = document.getElementsByClassName(selector);
    
    if (forms){
        for (let i = 0; i<forms.length; i++){

      if (forms[i].hasAttribute("connected")){
        
      }
      else {
        forms[i].setAttribute("connected", true);
        $(forms[i]).on('submit', function(evt) {
          evt.preventDefault();

          // Remove errors
          const errorDiv = $(evt.target).find('.errors');
          $(errorDiv).attr("hidden",true);
          $('.validation-error').remove();

          // Add class to be styled if desired
          const button = $(evt.target).find('button#AddToCart');

          $(button).addClass('is-adding');
          $(button).removeClass('is-added');

          try {
            console.log(evt.target);
            evt.target.parentElement.classList.add('is-adding');
          }
          catch(e){
            
          }
    
          ShopifyAPI.addItemFromForm(evt.target, (product) => {itemAddedCallback(product, evt.target, button)}, (req, status) => { itemErrorCallback(req, status, evt.target) });
      });
      }
    }
    }
  };

  var isSupportedCurrency = function(_cart) {

      const key = _cart.currency;

      if (freeShippingThreshold[key]){
        return true;
      }
      return false;
      
 }

  var getShippingThreshold = function(_cart) {
      
      for (var supportedCurrency in freeShippingThreshold){
        if (_cart.currency == supportedCurrency){
          const key = _cart.currency;
          return freeShippingThreshold[key];
        }
      }
      
  }

  var getShippingType = function(_cart){
    for (var supportedCurrency in freeShippingTypes){
        if (_cart.currency == supportedCurrency){
          const key = _cart.currency;
          return freeShippingTypes[key];
        }
    }
  }

   var updateShippingSliders = function(shippingType, remainder, barPercentage) {
     console.log('Updating shipping sliders');
    const sliderText = $('.snippet-shipping-slider-message');
    const sliders = $('.snippet-shipping-slider-progress');
     if (barPercentage >= 100){
        $(sliderText).text(`Your order qualifies for free ${shippingType} shipping!`);
        $(sliders).css('width', `100%`);
     }
     else {
        $(sliderText).text(`You are ${remainder} away from free ${shippingType} shipping!`);
        $(sliders).css('width', `${barPercentage}%`);
     }
  }

  itemAddedCallback = function (product, formElement, buttonElement) {
    console.log('item addded callback')
    $addToCart.removeClass('is-adding').addClass('is-added');

    //support variant selectors on collections
    formElement.parentElement.classList.remove('is-adding');
    
    if (buttonElement){
      $(buttonElement).removeClass('is-adding').addClass('is-added');
    }

    formElement.dispatchEvent(new Event('addedToCart'));

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, formElement) {

    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        if (typeof data.description === "string"){
          alert(data.description);
        }
        else {
          if (data.errors){
              console.log(data.errors);
              const errorDiv = $(formElement).find('.errors');
              $(errorDiv).attr("hidden",false);
            for (const key in data.errors){
              $(errorDiv).append(`<p class="validation-error">${key} ${data.errors[key][0]}</p>`);
          }
          }
          
        }
      }
    }
  };

  var getFeaturedProducts = function() {
    
  let html = "";
    
  if (window.theme?.featuredProducts.length > 0){
        window.theme.featuredProducts.forEach((product) => {
          html += `
          <div class="cart-featured-product">
          <a href="/products/${product.handle}">
          <img width="300" height="400" src="${product.featured_image}&width=200">
          <p>${product.title}</p>
          </a>
          </div>
          `;
        }); 
  }
  return html;
  }

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };
  
  var fbt = [],
      display_FGP = true,
      current_cart_items = [];



  buildCart = function (cart) {

    console.log('buildCart')
    // Start with a fresh cart div
    $cartContainer.empty();
    current_cart_items = [];
    var fbtItems = [];
    var fgp_items = [];
    var fbt_rendered = [];
    $('.custom-slide-fgp').html('');

    let threshold = null;
    let type = null;
    let shippingSlider = '';
    if (isSupportedCurrency(cart)){
      threshold = getShippingThreshold(cart);
      type = getShippingType(cart) ?? "";
      shippingSlider = `<div class="shipping-progress-empty">
          <p class = "shipping_text">You are ${window.currencySymbol}${threshold} away from free ${type} shipping!</p>
           <div class="shipping_bar_progress_bar">
            <div class="shipping_bar_progress" style="width: 0;"></div>
            </div>
            </div>`;
    }

    
    
    const featuredProductsHtml = getFeaturedProducts();

    // Show empty cart
    if (cart.item_count === 0) {
      $('#CartDrawer').addClass('empty');
      $cartContainer
        .append(`<div class="empty-cart">
        
        ${shippingSlider}
    
      
        <p class="empty-cart-message">Your cart is currently empty.</p>

                <div class="empty-cart-link wishlist">
                    <a href="/pages/swym-wishlist">Wishlist
                    <svg class="empty-cart-icon" aria-label="Wishlist icon" xmlns="http://www.w3.org/2000/svg" id="Icons" viewBox="0 0 64 64" width="20" height="20"><path d="M45.5,4A18.53,18.53,0,0,0,32,9.86,18.5,18.5,0,0,0,0,22.5C0,40.92,29.71,59,31,59.71a2,2,0,0,0,2.06,0C34.29,59,64,40.92,64,22.5A18.52,18.52,0,0,0,45.5,4ZM32,55.64C26.83,52.34,4,36.92,4,22.5a14.5,14.5,0,0,1,26.36-8.33,2,2,0,0,0,3.27,0A14.5,14.5,0,0,1,60,22.5C60,36.91,37.17,52.33,32,55.64Z"></path></svg>
                    </a>
                </div>
                <div class="empty-cart-link account">
                  <a href="#account">Account
                  <img alt="" id="login-icon" src="https://cdn.shopify.com/s/files/1/0876/3680/files/user_3.png?v=1679030216" width="20" height="20" class="empty-cart-icon"></a>

                </div>
                <div class="empty-cart-link shopNow">
                  <a href="/collections/latest">Shop now
                  <svg class="empty-cart-icon" aria-label="Cart icon" class="icon icon-cart" width="20" height="20" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2121 3.55H15.8V18H0.5V3.55H4.08793C4.4824 1.6705 6.15692 0.25 8.15 0.25C10.1431 0.25 11.8176 1.6705 12.2121 3.55ZM10.6589 3.55C10.3193 2.55725 9.40342 1.8238 8.31676 1.75525L8.15 1.75C6.99106 1.75 5.99789 2.50685 5.64105 3.55H10.6589ZM14.299 5.049H1.999V16.499H14.299V5.049Z" fill="black"></path></svg>
                  </a>
                </div>

                <div id="cart-featured-products" class="cart-featured-products">
                  ${featuredProductsHtml}
                </div>
                
                
                </div>`);


      
      cartCallback(cart);
      updateShippingSliders(getShippingType(cart), Shopify.formatMoney(getShippingThreshold(cart) * 100, settings.moneyFormat), 0);
      return;
    }
    else {
      $('#CartDrawer').removeClass('empty');
    }



    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

	display_FGP = true;

    
    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_large$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      //hide the gift card recipient property
      let domProperties = { ...cartItem.properties};
      delete domProperties['__shopify_send_gift_card_to_recipient'];
            
      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: domProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney((cartItem.line_price + cartItem.total_discount), settings.moneyFormat), 
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === (cartItem.line_price - cartItem.total_discount) ? false : true
      };

      
      items.push(item);
      current_cart_items.push(cartItem.handle);
      
      // check tags
      // FBT - means Frequently Bought Together
      // FGP - means Free Gift Products
      var isLastElement = index == cart.items.length -1;
      if(cartItem.url != '') {
		jQuery.getJSON(cartItem.url.split('?')[0] + '.js', function(product) {
          let usingLegacy = false;
          $.each(product.tags, function(i,tag) {
             fbt = [];
             if (tag.indexOf("FBT-") >= 0) {
               usingLegacy = true;
               if (!fbtItems.includes(tag)){
               fbt.push(tag);
               fbtItems.push(tag);
               }
               cartFBT(fbt_rendered);
             }

          });
          if (!usingLegacy){
            $.ajax({
                url: "/products/" + product.handle + "?view=style-with.json",
                success: function(response){
                  let res = JSON.parse(response);
                  if (res.products.length > 0){
                  var list_cart_title = jQuery('.FrequentlyBoughtTogether').find('h6');
                  list_cart_title.text('COMPLETE THE LOOK');
                  list_cart_title.removeClass('hide');
                  var list_cart = jQuery('.FrequentlyBoughtTogether').find('.custom-slide-fbt');
                  for (let i = 0; i < res.products.length; i++){

                    jQuery.getJSON('/products/' + res.products[i].handle + '.js', function(product) {

                      if (fbt_rendered.find(p => p.handle == product.handle)){
                
                      }
                      else {
                        fbt_rendered.push(product);
                        $(list_cart).empty();
                        
                        for (let j=0; j<fbt_rendered.length; j++){
                          appendFbtItem(fbt_rendered[j], list_cart);
                        }
                      }
                      
                    });

                    
                  }
                  }
                }});
          }
        });
      }
      
    });
    

    
    


    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      localCurrency: isSupportedCurrency(cart),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      priceRemaining: Shopify.formatMoney(((getShippingThreshold(cart) * 100) - cart.total_price), settings.moneyFormat),
      shippingBarPercentage: (cart.total_price / (getShippingThreshold(cart) * 100)) * 100,
      qualifiesForFreeShipping: (((cart.total_price / (getShippingThreshold(cart) * 100)) * 100) >= 100) ? true : false,
      freeShippingType: getShippingType(cart) ?? '',
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      fgpProducts: renderSuggestedProducts()
    }

    try {
      
      updateShippingSliders(data.freeShippingType, data.priceRemaining, data.shippingBarPercentage);
    }
    catch(e){
      console.log('Failed to update shipping slider');
    }
    
    
    $cartContainer.append(template(data));
    cartCallback(cart);

  };

  function appendFbtItem(product, list_cart){
    if(product.available){
    list_cart.append('<div id="' + product.url.replace("/products/", "") +'" class="slide-fbt"><a class="left-side" href="' + product.url +'"><img style="max-width: 100%;max-height: 150px;" src="' + product.images[0].replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_large$1') + '" /></a><div class="right-side"><h4><a href="' + product.url + '">' + product.title + '</a></h4><span class="money">' + Shopify.formatMoney(product.price, settings.moneyFormat) + '</span> <a href="' + product.url +'" attr-id="' + product.variants[0].id +'" class="btn add-to-bag-custom-x">Add to cart</div></div></div>');     
  }
  }
  
  cartFBT = function(fbt_rendered) {

    var recommendations_cart = $.unique(fbt);
    var list_cart = jQuery('.FrequentlyBoughtTogether').find('.custom-slide-fbt');
    var list_cart_title = jQuery('.FrequentlyBoughtTogether').find('h6');
    if (recommendations_cart.length) {
      var list_cart = jQuery('.FrequentlyBoughtTogether').find('.custom-slide-fbt');
      var list_cart_title = jQuery('.FrequentlyBoughtTogether').find('h6');
      for (var i=0; i<recommendations_cart.length; i++) {
        var product_handle = recommendations_cart[i].replace('FBT-','');
        if (current_cart_items.indexOf(product_handle) >= 0) {

        } else {
          list_cart_title.text('COMPLETE THE LOOK');
          list_cart_title.removeClass('hide');

          jQuery.getJSON('/products/' + product_handle + '.js', function(product) {
            
              if (fbt_rendered.find(p => p.handle == product.handle)){
                
              }
              else {
                fbt_rendered.push(product);
                
                $(list_cart).empty();
                
                for (let j=0; j<fbt_rendered.length; j++){
                  appendFbtItem(fbt_rendered[j], list_cart);
                }
              }
          
          });

        }
      }
    }
    else {
    }
  };

  function renderFgpItem(product, fgpContainer){
    if (product.available){
              if (product.compare_at_price) {
                var saleprice = '<span class="saleprice" style="text-decoration: line-through;">' + Shopify.formatMoney(product.compare_at_price, settings.moneyFormat) + '</span><span class="space" style="text-decoration: none;">&nbsp&nbsp</span>';
              }
              else var saleprice = "";

      const itemHtml = `<div id="fgp_${product.handle}" class="slide-fbt"><a class="left-side" href="/products/${product.handle}"><img style="max-width: 100%;max-height: 150px;" src="${product.featured_image.replace(/(\.jpg|\.png|\.jpeg|\.gif)/, '_large$1')}" /></a>
    <div class="right-side"><h4><a href="/products/${product.handle}">${product.title}</a></h4><span class="money">${Shopify.formatMoney(product.price, settings.moneyFormat)}&nbsp${saleprice}</span> <div attr-id="${product.variants[0].id}" class="btn add-to-bag-custom">Add to cart</div></div></div>`;

      return itemHtml;
  }
    else {
      return "";
    }
  }
  
  renderSuggestedProducts = function() {

    let title = "A little something extra"
    let html = `<h6 class="drawer__title h2 page--title" style="margin-bottom: 20px;">${title}</h6>`;
    
    const fgpContainer = $('#fgp-product-container');
    
    if (display_FGP == true && window.theme?.fgpProducts) {

        window.theme.fgpProducts.forEach((fgpProduct)=>{
           html += renderFgpItem(fgpProduct, fgpContainer);
        })
    }

    return html;

  };

  

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
	if (window.Shopify && Shopify.StorefrontExpressButtons) {
		Shopify.StorefrontExpressButtons.initialize();
	}  
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-remove', function() {
        if (isUpdating) {
            return;
        }

        var $el = $(this),
            line = $el.data('line'),
            qty = 0;

        // Remove all items of this type from the cart
        if (line) {
            updateQuantity(line, qty);
        }

    });


    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      $('.ajaxcart__inner').addClass('isUpdating');

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      

      let indicator; 
      if (qty === 0) {
        $row.parent().addClass('is-removed');
        //indicator = $('.ajaxcart__row[data-line="' + line + '"]').append(settings.loadingIndicator);
      }

      // Remove
      // Slight delay to make sure removed animation is done

      ShopifyAPI.changeItem(line, qty, adjustCartCallback);

      
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {

    //rebuild cart if there was an error
    if (!cart){
      console.log('Cart error')
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }
    else {
      // Update quantity and price
      updateCountPrice(cart);

      isUpdating = false;
      ShopifyAPI.getCart(buildCart);

      /*
      // Reprint cart on short timeout so you don't see the content being removed
      setTimeout(function() {
        isUpdating = false;
        ShopifyAPI.getCart(buildCart);
      }, 150)
      */
    }

  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));
